import BaseService from './BaseService.js'

export default {
  get(id) {
    return BaseService.get(`Submission/${id}`)
  },
  getSubmissions() {
    return BaseService.get(`Submission/User`)
  },
  post(submission) {
    return BaseService.post(`Submission`, submission)
  },
  put(submission) {
    return BaseService.put(`Submission`, submission)
  },
  delete(id) {
    return BaseService.delete(`Submission/${id}`)
  },
  getFull(id) {
    return BaseService.get(`Submission/Full/${id}`)
  },
  validate(submissionId) {
    return BaseService.post('Submission/Validate', submissionId)
  },
  submit(submission) {
    return BaseService.post('Submission/Submit', submission)
  },
  getRequiredData() {
    return BaseService.get('Submission/RequiredData', true)
  },
  search(submissionID, entityName, dateFrom, dateTo, userName, userEmail) {
    return BaseService.post('Submission/Search', { submissionID, entityName, dateFrom, dateTo, userName, userEmail })
  }
}
